/* eslint-disable */
export default {
  common: require('./common.json'),
  layouts: {
    auth: require('./layouts/auth.json'),
    quiz: require('./layouts/quiz.json'),
  },
  pages: {
    auth: {
      login: require('./pages/auth/login.json'),
    },
  },
  routes: require('./routes.json'),
  components: {
    app: {
      settingsDrawer: require('./components/app/settings-drawer.json'),
    },
    quiz: {
      drawer: {
        currentStatus: require('./components/quiz/drawer/current-status.json'),
      },
    },
  },
};
